(function () {
	'use strict';

	if (!document.querySelector('.uvindex')) {
		return;
	}

	var mediumBreakpoint = 1024;
	var placeholders = {};

	function createPlaceholder(element) {
		var id = element.id || Math.random().toString(36).slice(2, 11);
		element.id = id;

		if (!placeholders[id]) {
			var placeholder = document.createElement('div');
			placeholder.setAttribute('data-placeholder-for', id);
			element.parentNode.insertBefore(placeholder, element);
			placeholders[id] = placeholder;
		}
	}

	function moveElements(targetContainer, elements, after = false) {
		elements.forEach(function (element) {
			createPlaceholder(element);
			if (after) {
				targetContainer.insertAdjacentElement('afterend', element);
			} else {
				targetContainer.insertBefore(element, targetContainer.firstChild);
			}
		});
	}

	function returnToOriginalPosition(elements) {
		elements.forEach(function (element) {
			var placeholder = document.querySelector(`[data-placeholder-for="${element.id}"]`);
			if (placeholder) {
				placeholder.parentNode.insertBefore(element, placeholder);
				placeholder.remove();
				delete placeholders[element.id];
			}
		});
	}

	function uvIndexLocationPlacement() {
		var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		var locationContainers = Array.from(document.querySelectorAll('.uvindex-row.uvindex-location'));

		var mainContent = document.querySelector('.uvindex-main-content');
		var sideContent = document.querySelector('.uvindex-side-content');

		if (screenWidth <= mediumBreakpoint) {
			moveElements(mainContent, locationContainers);
		} else {
			returnToOriginalPosition(locationContainers);
		}
	}

	function uvIndexWeeklyPlacement() {
		var screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
		var weeklyContainers = Array.from(document.querySelectorAll('.uvindex-row.uvindex-weekly'));
		var chartContainer = document.querySelector('.uvindex-row.uvindex-chart');

		if (screenWidth <= mediumBreakpoint) {
			moveElements(chartContainer, weeklyContainers, true);
		} else {
			returnToOriginalPosition(weeklyContainers);
		}
	}

	function init() {
		uvIndexLocationPlacement();
		uvIndexWeeklyPlacement();
	}

	init();
	window.addEventListener('resize', init);
})();
